import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaterialManufacturer } from '../models/material/material-manufacturer.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class MaterialManufacturerService extends RequestService<MaterialManufacturer> {
  static PATH = '/material/manufacturer';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, MaterialManufacturerService.PATH, globalService.debugUrl);
  }
}
